import type { JSX } from "react";
import * as React from "react";
import Item, { Props as LinkItemProps } from "./Item";
import styles from "./styles.scss";

class LinkList extends React.Component<React.PropsWithChildren<unknown>> {
  static Item: (props: LinkItemProps) => JSX.Element;

  render() {
    return <ul className={styles.root}>{this.props.children}</ul>;
  }
}

LinkList.Item = Item;

export default LinkList;
